import React from "react";
import Container from "react-bootstrap/Container";
import { SideBar } from "./sideBar";
import { NavBar } from "./navBar";
import { Row, Card } from 'react-bootstrap';
import { useAuth } from "../contexts/AuthContext";
import { useTranslation } from 'react-i18next';

export const MainDashboardClient = () => {
  const { t } = useTranslation();
  const { clientId } = useAuth();

  // Show sidebar if user has clientId
  const hasPermissions = clientId !== null && clientId !== undefined;

  return (
    <React.Fragment>
      {hasPermissions && <SideBar />}
      <Container>
        <NavBar />
        <Container>
          <Row>
            <Card>
              <Card.Header>
                <Card.Title as="h5">{t('dashboard.pageTitle')}</Card.Title>
              </Card.Header>
              <Card.Body>
                <p>{t('dashboard.welcomeMessage')}</p>
              </Card.Body>
            </Card>
          </Row>
        </Container>
      </Container>
    </React.Fragment>
  );
};
